<template>
  <p>
    Etes-vous sûr de vouloir modifier le type de forfait en {{ typeForfaitTransport.typeForfait }} ?<br>
    Les tranches seront conservées, mais leurs paliers ne seront certainement plus cohérents.
  </p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['typeForfaitTransport'])
  }
}
</script>
